/*
 * @Author: zhao - 🍉
 * @Date: 2021-12-17 14:28:10
 * @LastEditTime: 2022-02-14 23:13:42
 * @LastEditors: zhao - 🍉
 * @Description: 
 * @FilePath: /zhzj-admin/src/utils/request.js
 */
import { message } from "antd";
import axios from "axios";
import { handleExportParams } from ".";
import { HashRouter } from "react-router-dom";
import { API_NAME } from "../axios/config";
const router = new HashRouter();
let login_invalid = false; //登录失效
const request = axios.create({
  method: 'POST',
  timeout: 30000,
  baseURL: API_NAME
})

request.interceptors.request.use(config => {
  config.headers = Object.assign(handleExportParams(),  config.headers)
  return config
})

request.interceptors.response.use(response => {
    console.log()
  if (response.data.code === 0)
      return response.config.autoParse === false ? response.data :  response.data.data
  else if (response.data.code) {
    message.error(response.data.message)
    return Promise.reject({ code: response.data.code, message: response.data.message, data: response.data.data });
  }
  else
      return response.data
},
error => {
  if (error.response) {
      if (error.response.status === 401 && login_invalid === false) {
          login_invalid = true;
          message.error('登录已失效', 1).then(() => {
              if (handleExportParams().employeeId) {
                  router.history.push('/login');
              } else {
                  router.history.push('/merchantLogin');
              }
          });
      }
      return Promise.reject({ code: error.response.code, message: typeof error.response.data === 'object' ? error.response.data.message : error.response.code });
  }
  return Promise.reject(error);
})


export default request


// WEBPACK FOOTER //
// ./src/utils/request.js